export const onCompleteErrors = {
  denied: 'denied',
  noDeliveryMethod: 'no_delivery_method',
}
